$(document).ready(function () {
    /**
     * Take to Cart
     */
    $('.btn:not(.cta)').on('click', function (event) {
        $('html, body').animate({
            scrollTop: $("#cart").offset().top
        }, 1000);
    });

    /**
     * Shopping Cart
     */
    /// subscribe box
    $('#subscribeBox').on("click", function () {
        $(this).find('.cart__checkbox').toggleClass('checked');
        $('#cartCTA').toggleClass('disabled');
    })

    //// activate subscribe prices    
    $('.cart__mode-cta').on('click', function () {
        let thisBtn = $(this);
        $('.cart__mode-cta').removeClass('active');
        thisBtn.addClass('active');

        if (thisBtn.hasClass('subscribe')) {
            $('#choosePrices').attr('data-subscribe', 'subscribe');
            $('#subscribeWrap').removeClass('hide').addClass('show');
            $('#cartCTA').addClass('disabled');
        } else {
            resetSubscribe();
        }
        $('.cart__product.active').trigger("click");
    });

    function resetSubscribe() {
        $('#choosePrices').attr('data-subscribe', 'false');
        $('#subscribeWrap').removeClass('show').addClass('hide');
        $('#cartCTA').removeClass('disabled');
        $('#subscribeBox .cart__checkbox').removeClass('checked');
    }
    
    //// set prices
    function setLinks() {
        let thisProduct = $(this);
        let link = 'data-link';
        const subscribe = $('#choosePrices').attr('data-subscribe');

        if (subscribe === 'subscribe') {
            link = 'data-subscribe-link';
        } else {
            link = 'data-link';
        }

        let param = $('#cartCTA').attr('data-param');

        $('#cartCTA').attr('href', thisProduct.attr(link) + param);
    }
    
    function activeProduct() {
        let thisProduct = $(this);
        let amount = 'data-price',
            retail = 'data-retail',
            link = 'data-link',
            ship = 'data-shipping';
        const subscribe = $('#choosePrices').attr('data-subscribe');
        
        if (subscribe === 'subscribe') {
            amount = 'data-subscribe-price';
            link = 'data-subscribe-link';
            ship = 'data-subscribe-shipping';

            $('.cart__details').addClass('cart__details--subscribe');

        } else {
            amount = 'data-price';
            link = 'data-link';
            ship = 'data-shipping';

            $('.cart__details').removeClass('cart__details--subscribe');
        }
        
        $('.cart__product').removeClass('active');
        thisProduct.addClass('active');

        $('.cart__current-value').html('$' + thisProduct.attr(amount));
        $('.cart__retail-value').html('$' + thisProduct.attr(retail));
        $('.cart__shipping-value').html(thisProduct.attr(ship));
    }
    
    $('.cart__product').on('click', setLinks);
    $('.cart__product').on('click', activeProduct);
    $('.cart__product.active').trigger("click"); 
});
